export function RegularTag() {
  return (
    <div className="h-[22px] text-[#CC5C2D] bg-[#FBEFEF] rounded-[8px] px-2 pb-[1px] text-[12px] font-[500] flex items-center justify-center">
      Regular
    </div>
  )
}
